import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyAccountLandingPageYourBenefits from './LoyaltyAccountLandingPageYourBenefits'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import LoyaltyAccountLandingPageUserActivities from './LoyaltyAccountLandingPageUserActivities'
import LoyaltyLandingPageNextTierBenefitsContent from './LoyaltyLandingPageNextTierBenefitsContent'

const Section = styled(VerticalSpacer)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

function LoyaltyAccountBenefitsProgressContent() {
  const [currentTier, _currentTierName, nextTier] = useCurrentLoyaltyTier()

  return <Section gap={24}>
    {currentTier !== 'bronze' && <LoyaltyAccountLandingPageYourBenefits />}
    {nextTier && <LoyaltyLandingPageNextTierBenefitsContent nextTier={nextTier} />}
    <LoyaltyAccountLandingPageUserActivities />
  </Section>
}

export default LoyaltyAccountBenefitsProgressContent
